import Detail from './Detail'
//import List from './List'

export default {
    Detail,
   // List
}
